module.exports = __webpack_public_path__ + "img/esiLogo.ee726788.png";